import React from "react";
import {withTranslation} from "react-i18next";
import i18next from "../../resource/i18n";

class MVenueInquiryComp extends React.Component {
	render() {
		const {t} = this.props;
		let rLink = "https://docs.google.com/forms/d/e/1FAIpQLSdytO-oLRpFeMrLTQ_XGfo3Ea1faOzXRaV25_cOZE1o0E-CEQ/viewform?usp=sf_link";
		if (i18next.language === "en" ) {
			rLink = "https://docs.google.com/forms/d/e/1FAIpQLSeMnEp8ZXUSvK7EVHHj5pAc4Q3rRoZ18U09tbFc0tDvKTwfvw/viewform";
		}
		return (
			<React.Fragment>
				<div id="inquiry" className="list list-type9">					
					<div className="list-con">
						<p className="lg-ttl">{t('Venue_inquiry_title')}</p>
						<div className="list-txt">
							<ul>
								<li>
									<p className="txt txt-indent">
										{t('Venue_inquiry_step1_title')} <br />
										<span className="hyphen">
											{t('Venue_inquiry_step1_desc')} 
											<a href={rLink} target="_blank" className="link" rel="noopener noreferrer">
												{t('Venue_inquiry_step1_link')}
											</a>
										</span>
									</p>
								</li>
								<li>
									<p className="txt">
										{t('Venue_inquiry_step2_desc')}
									</p>
								</li>
							</ul>
							<p className="txt ps-txt">
								<span>{t('Venue_inquiry_notice1')}</span><br />
								<span>{t('Venue_inquiry_notice2')}</span>
							</p>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}
export default withTranslation()(MVenueInquiryComp);
